import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { IOpenableButtonProps } from "@/eworkitComponents";
import { ModalButton } from "@/views/components/Modal";

import { TaskConfirmationDialogModal } from "./TaskConfirmationDialogModal";

export interface IAcceptTaskModalButtonProps extends Omit<IOpenableButtonProps, "openable"> {
  onAccept?: (comment: string) => void;
  openable?: IOpenableButtonProps["openable"];
}

export const AcceptTaskModalButton: FC<IAcceptTaskModalButtonProps> = memo(({ onAccept, openableProps, ...props }) => {
  const { t } = useTranslation("session");

  return (
    <ModalButton
      openable={TaskConfirmationDialogModal}
      openableProps={{
        header: t("TASKS.DIALOG_MODAL.HEADER"),
        confirmationText: t("TASKS.DIALOG_MODAL.CONFIRM_TASK_QUESTION"),
        cancelButtonLabel: t("TASKS.DIALOG_MODAL.BUTTON_REJECT"),
        acceptButtonLabel: t("TASKS.DIALOG_MODAL.BUTTON_CONFIRM"),
        icon: "warning-2",
        onAccept,
        ...openableProps,
      }}
      {...props}
    />
  );
});
